import React, { useState, useEffect } from "react";
import { G2, Pie } from "@ant-design/plots";
import EChartsReact from "echarts-for-react";
import { Card } from "antd";
import { dayjs } from "../../../Utilities/dayjs";
import { useTheme } from "../../Context/ThemeContext";
import { LineChart } from "@mui/x-charts/LineChart";
import "../../Common/Dashboardlayout.css";
// import { dataset } from "./GDPperCapita";

export const IncomeExpensesGraphs = (props: any) => {
  const G = G2.getEngine("canvas");
  const data: any = [
    {
      type: "Expenses",
      // value : 100,
      total: props.value
        ? props.cashOrAccrual === "Accrual"
          ? props.value?.expenseDue + props.value?.incomeDue
          : props.cashOrAccrual === "Cash"
          ? props.value?.expenseReceived + props.value?.incomeReceived
          : 0
        : 0,
      // total: props.value?.expenseDue + props.value?.incomeDue,
      value: props.value
        ? props.cashOrAccrual === "Accrual"
          ? props.value?.expenseDue
          : props.cashOrAccrual === "Cash"
          ? props.value?.expenseReceived
          : 0
        : 0,
      backgroundColor: "red",
    },
    {
      type: "Income",
      // value : 60
      total: props.value
        ? props.cashOrAccrual === "Accrual"
          ? props.value?.expenseDue + props.value?.incomeDue
          : props.cashOrAccrual === "Cash"
          ? props.value?.expenseReceived + props.value?.incomeReceived
          : 0
        : 0,
      //  total: props.value?.expenseDue + props.value?.incomeDue,
      value: props.value
        ? props.cashOrAccrual === "Accrual"
          ? props.value?.incomeDue
          : props.cashOrAccrual === "Cash"
          ? props.value?.incomeReceived
          : 0
        : 0,
      // props.value?.incomeDue,
    },
  ];

  const cfg: any = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.95,
    color: ["orange", "#1677ff"],
    legend: false,
    label: {
      type: "spider",
      labelHeight: 40,
      formatter: (data: any, mappingData: any) => {
        const group = new G.Group({});
        group.addShape({
          type: "circle",
          attrs: {
            x: 0,
            y: 0,
            width: 40,
            height: 30,
            r: 5,
            fill: mappingData.color,
          },
        });
        group.addShape({
          type: "text",
          attrs: {
            x: 10,
            y: 8,
            text: `${data.type}`,
            fill: mappingData.color,
          },
        });
        group.addShape({
          type: "text",
          attrs: {
            x: 0,
            y: 25,
            text: `${data.value} (${
              data.total
                ? Math.round(((data.value * 100) / data.total) * 100) / 100
                : 0
            }%)`,
            fill: "rgba(0, 0, 0, 0.65)",
            fontWeight: 700,
          },
        });
        return group;
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  };

  const config = cfg;
  return (
    <>
      {" "}
      <Pie style={{ height: "185px" }} {...config} />
    </>
  );
};
// const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
// const pData = [2400, 1398, 4800, 3908, 4800, 3800, 4300];
// const xLabels = [
//   "Page A",
//   "Page B",
//   "Page C",
//   "Page D",
//   "Page E",
//   "Page F",
//   "Page G",
// ];

export const SalesBarCharts = ({ data, hideDasBackground }: any) => {
  const themeData: any = useTheme();
  const initialMonths = [
    `Aug ${dayjs().format("YY")}`,
    `Sep ${dayjs().format("YY")}`,
    `Oct ${dayjs().format("YY")}`,
    `Nov ${dayjs().format("YY")}`,
    `Dec ${dayjs().format("YY")}`,
    `Jan ${dayjs().add(1, "year").format("YY")}`,
    `Feb ${dayjs().add(1, "year").format("YY")}`,
    `Mar ${dayjs().add(1, "year").format("YY")}`,
    `Apr ${dayjs().add(1, "year").format("YY")}`,
    `May ${dayjs().add(1, "year").format("YY")}`,
    `Jun ${dayjs().add(1, "year").format("YY")}`,
    `jul ${dayjs().add(1, "year").format("YY")}`,
  ];

  const options: any = {
    xAxis: {
      type: "category",
      data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    },
    yAxis: {
      type: "value",
    },
    legend: {
      data: ["Actual", "Forecast"],
    },
    series: [
      {
        name: "Actual",
        data: [0, 20, 30, 45, 40, 50, 51, 52, 50, 49, 56, 55],
        type: "line",
        smooth: true,
        lineStyle: {
          color: "green",
        },
      },
      {
        name: "Forecast",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          55,
          48,
          56,
          57,
        ],
        type: "line",
        smooth: true,
        lineStyle: {
          color: "red",
          type: "dashed",
        },
      },
    ],
  };

  const option: any = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#fff",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: false },
        saveAsImage: { show: true },
      },
    },
    legend: {
      data: ["Sales", "Purchase"],
    },
    xAxis: [
      {
        type: "category",
        data:
          !data?.salesSummary || data?.salesSummary?.graphData?.length === 0
            ? initialMonths?.map((i) => i)
            : data?.salesSummary?.graphData?.map((s: any) => s.label),
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "Purchase",
        // min: 0,
        // max: 2500,
        // interval: 500,
        // axisLabel: {
        //   formatter: "{value} Rs.",
        // },
      },
    ],
    series: [
      {
        name: "Sales",
        type: "bar",

        tooltip: {
          valueFormatter: function (value: any) {
            return value + " Rs.";
          },
        },
        data: hideDasBackground
          ? Array(data?.salesSummary?.graphData?.length || 12).fill("****")
          : !data?.salesSummary || data?.salesSummary?.graphData?.length === 0
          ? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          : data?.salesSummary?.graphData?.map((s: any) =>
              s.value?.sales ? Math.abs(s.value.sales) : 0
            ),
      },
      {
        name: "Purchase",
        type: "bar",
        tooltip: {
          valueFormatter: function (value: any) {
            return value + " Rs.";
          },
        },
        data: hideDasBackground
          ? Array(data?.salesSummary?.graphData?.length || 12).fill("****")
          : !data?.salesSummary || data?.salesSummary?.graphData?.length === 0
          ? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          : data?.salesSummary?.graphData?.map((s: any) =>
              s.value?.purchase ? Math.abs(s.value.purchase) : 0
            ),
      },
    ],
  };
  const [select, setSelect] = useState("sales");
  const [salesPurchase, setSalesPurchase] = useState(false);
  const [salesForecast, setSalesForecast] = useState(false);
  const [exp, setExp] = useState(false);

  useEffect(() => {
    select === "sales" ? setSalesPurchase(true) : setSalesPurchase(false);
    select === "forecast" ? setSalesForecast(true) : setSalesForecast(false);
    select === "expenses" ? setExp(true) : setExp(false);
    // setDefaultValue;
  }, [select]);
  return (
    <div className="dasGraph">
      <Card>
        <select
          style={{
            width: "45%",
            height: "40px",
            color: themeData?.themeData?.themeColor,
            borderRadius: 5,
            fontWeight: 500,
            padding: "5px",
            border: "1px solid white",
            fontSize: "18px",
          }}
          value={select}
          onChange={(e: any) => setSelect(e.target.value)}
        >
          <option value="sales" style={{ fontSize: "14px" }}>
            &#160;Total Sales / Purchase
          </option>
          <option value="forecast" style={{ fontSize: "14px" }}>
            &#160; Sales Forecast
          </option>
          <option value="expenses" style={{ fontSize: "14px" }}>
            &#160; Total Expenses
          </option>
        </select>

        {salesPurchase && (
          <>
            {/* <div>
                <Typography.Title
                  level={4}
                  style={{
                    // marginTop: 10,
                    // fontFamily: "REM,sans-serif",
                    fontWeight: 500,
                    color: themeData?.themeData?.themeColor,
                    padding: "15px",
                  }}
                >
                  Total Sales / Purchase
                  <br />
                </Typography.Title>
              </div> */}
            <div style={{ paddingLeft: "20px" }}>
              <EChartsReact
                className="EchartDisplay"
                option={option}
                opts={{ renderer: "svg" }}
                style={{
                  marginTop: "5px",
                  height: "329px",
                  padding: 0,
                  // width: "100%",
                }}
              />
            </div>
          </>
        )}

        {salesForecast && (
          <>
            {" "}
            {/* <div>
                <Typography.Title
                  level={4}
                  style={{
                    padding: "15px",
                    // fontFamily: "REM,sans-serif",
                    fontWeight: 500,
                    color: themeData?.themeData?.themeColor,
                  }}
                >
                  Sales forecasting
                </Typography.Title>
              </div> */}
            <div style={{ paddingLeft: "10px" }}>
              <EChartsReact
                className="EchartDisplay"
                option={options}
                opts={{ renderer: "svg" }}
                style={{
                  marginTop: "5px",
                  height: "300px",
                  padding: 0,
                  // width: "100%",
                  // marginLeft: "10px",
                }}
              />
            </div>
          </>
        )}

        {exp && (
          <>
            {/* <div>
                <Typography.Title
                  level={4}
                  style={{
                    padding: "15px",
                    // fontFamily: "REM,sans-serif",
                    fontWeight: 500,
                    color: themeData?.themeData?.themeColor,
                  }}
                >
                  Total Expenses
                </Typography.Title>
              </div> */}
            <div style={{ paddingLeft: "10px" }}>
              <LineChart
                xAxis={[{ data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] }]}
                series={[
                  {
                    data: [2, 3, 5.5, 8.5, 1.5, 5, 1, 4, 3, 8, 9, 10],
                    showMark: ({ index }) => index % 2 === 0,
                  },
                ]}
                width={500}
                height={300}
              />
            </div>
          </>
        )}
      </Card>
    </div>
  );
};
